import SVG from "react-inlinesvg";
import { useDispatch } from 'react-redux';
import { useProductionSitesContext } from '../redux/ProductionSitesContext';
import ImportFromFile from "../../components/ImportFromFile";
import { ProductionSite } from '../models/ProductionSitesModel';
import * as actions from '../redux/ProductionSitesActions'
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

const ImportProductionSites = () => {
    const dispatch = useDispatch();
    const productionSitesContext = useProductionSitesContext();
    const importingProductionSite = productionSitesContext.importedProductionSite as (ProductionSite | null);
    const productionSiteToOverwrite = productionSitesContext.productionSiteToOverwrite as (ProductionSite | null);

    const handleImportFileSelected = async (file: File | null) => {
        if (file) {
            dispatch(actions.loadImportedProductionSite(file));
        }
    }
    
    const handleImport = async (file: File, dryRun: boolean): Promise<{ success: boolean, messages: string[] }> => {
        const text = await file.text()
        const productionSite = JSON.parse(text) as ProductionSite
        dispatch(actions.saveProductionSite(productionSite))
        return { success: true, messages: [] };
    }

    const handleResetImport = () => {
        dispatch(actions.resetImportProductionSite());
    }

    return (
        
        <ImportFromFile
            formTitle="Import Production Site"
            enableDryRun={false}
            className="border-0 bg-white rounded mx-2 col-2"
            onImport={handleImport}
            onFileSelected={handleImportFileSelected}
            onReset={handleResetImport}
            closeOnDone={true}
        >
            <ImportFromFile.ImportButton>
                <div className="d-flex justify-content-center align-content-center">
                    <div className="h1 text-primary mt-2">
                        <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Import.svg")} className="svg-icon-md" />
                    </div>
                    <div className="ml-3 mt-4">
                        Import site
                    </div>
                </div>
            </ImportFromFile.ImportButton>
            <ImportFromFile.PopupContent>
            {importingProductionSite &&
                <div className="form-row">
                    <div className='col-6'>
                        <h5>Existing data</h5>
                        {productionSiteToOverwrite ?
                        <div className="form-group">
                            <label className="lighter">Code</label>
                            <div>{productionSiteToOverwrite.code}</div>
                            <label className="lighter">Production Site Name</label>
                            <div>{productionSiteToOverwrite.name}</div>
                            <label className="lighter">Country Code</label>
                            <div>{productionSiteToOverwrite.countryCode}</div>
                            <label className="lighter">IANA Time Zone</label>
                            <div>{productionSiteToOverwrite.ianaTimeZone}</div>
                            <label className="lighter">Available Operations</label>
                            <div>{productionSiteToOverwrite.availableOperations?.join(', ')}</div>
                            <label className="lighter">Centiro Sender</label>
                            <div>{productionSiteToOverwrite.shippingConfiguration?.centiroSenderCode}</div>
                            <label className="lighter">EORI Number</label>
                            <div>{productionSiteToOverwrite.shippingConfiguration?.eoriNumber}</div>
                            <label className="lighter">Support Carrier Overrides</label>
                            <div>{productionSiteToOverwrite.shippingConfiguration?.carrierOverridesSupported ? "Yes" : "No"}</div>
                        </div> :
                        <div className="form-group production-site-import-changed">
                            '{importingProductionSite.code}' production site doesn't exist yet
                        </div>
                        }
                    </div>
                    <div className='col-6'>
                        <div className="form-group">
                            <h5>Imported data</h5>
                            <label className="lighter">Code</label>
                            <div className="production-site-import-unchanged">{importingProductionSite.code}</div>
                            <label className="lighter">Production Site Name</label>
                            <div className={productionSiteToOverwrite && productionSiteToOverwrite.name !== importingProductionSite.name ? "production-site-import-changed" : "production-site-import-unchanged"}>{importingProductionSite.name}</div>
                            <label className="lighter">Country Code</label>
                            <div className={productionSiteToOverwrite && productionSiteToOverwrite.countryCode !== importingProductionSite.countryCode ? "production-site-import-changed" : "production-site-import-unchanged"}>{importingProductionSite.countryCode}</div>
                            <label className="lighter">IANA Time Zone</label>
                            <div className={productionSiteToOverwrite && productionSiteToOverwrite.ianaTimeZone !== importingProductionSite.ianaTimeZone ? "production-site-import-changed" : "production-site-import-unchanged"}>{importingProductionSite.ianaTimeZone}</div>
                            <label className="lighter">Available Operations</label>
                            <div className={productionSiteToOverwrite && productionSiteToOverwrite.availableOperations?.join(', ') !== importingProductionSite.availableOperations?.join(', ') ? "production-site-import-changed" : "production-site-import-unchanged"}>{importingProductionSite.availableOperations?.join(', ')}</div>
                            <label className="lighter">Centiro Sender</label>
                            <div className={productionSiteToOverwrite && productionSiteToOverwrite.shippingConfiguration?.centiroSenderCode !== importingProductionSite.shippingConfiguration?.centiroSenderCode ? "production-site-import-changed" : "production-site-import-unchanged"}>{importingProductionSite.shippingConfiguration?.centiroSenderCode}</div>
                            <label className="lighter">EORI Number</label>
                            <div className={productionSiteToOverwrite && productionSiteToOverwrite.shippingConfiguration?.eoriNumber !== importingProductionSite.shippingConfiguration?.eoriNumber ? "production-site-import-changed" : "production-site-import-unchanged"}>{importingProductionSite.shippingConfiguration?.eoriNumber}</div>
                            <label className="lighter">Support Carrier Overrides</label>
                            <div className={productionSiteToOverwrite && productionSiteToOverwrite.shippingConfiguration?.carrierOverridesSupported !== importingProductionSite.shippingConfiguration?.carrierOverridesSupported ? "production-site-import-changed" : "production-site-import-unchanged"}>{importingProductionSite.shippingConfiguration?.carrierOverridesSupported ? "Yes" : "No"}</div>
                        </div>
                    </div>
                </div>
            }
            </ImportFromFile.PopupContent>
        </ImportFromFile>
    );
}

export default ImportProductionSites